export default __webpack_public_path__ + "static/media/flexibleTopupIcon.064ae6b6.svg";